import React from 'react';

export const hamburger = (
  <svg enableBackground="new 0 0 100 100" id="Layer_1" version="1.1" viewBox="0 0 100 100"><g><polyline points="20.1,39.3 80.1,39.3 80.1,37.3 20.1,37.3  "/><polyline points="20.1,53.8 80.1,53.8 80.1,51.8 20.1,51.8  "/><polyline points="20.1,68.3 80.1,68.3 80.1,66.3 20.1,66.3  "/></g></svg>
);


// WEBPACK FOOTER //
// ./src/components/shared/svg-images/icons.js